import styled, {css} from 'styled-components';
import {FieldErrorMessage} from '@chekinapp/ui';
import {CustomIcon} from '../CustomIcon';

const disabledOpacity = 0.4;
const checkBoxSize = {
  width: '24px',
  height: '24px',
};

type CheckboxWrapperProps = {
  disabled?: boolean;
};

export const ErrorMessage = styled(FieldErrorMessage)`
  font-family: inherit;
  text-align: right;
  color: #f84b7a;
  font-size: 11px;
  position: absolute;
  right: 0;
  bottom: -20px;

  span:last-child {
    white-space: normal;
  }
`;

export const Content = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #152946;
`;
export const CheckboxWrapper = styled.div<CheckboxWrapperProps>`
  cursor: pointer;
  column-gap: 12px;
  text-align: left;
  min-width: 225px;
  display: flex;
  color: #161643;
  align-items: center;
  font-weight: 400;

  & div {
    width: '${checkBoxSize.width}';
  }

  ${props =>
    props.disabled &&
    css`
      opacity: ${disabledOpacity};
      cursor: not-allowed;
    `};
`;

export const AcceptIconImg = styled(CustomIcon)`
  position: absolute;
  user-select: none;
  right: 0;
`;

export const CheckedRoundCheckbox = styled.div`
  background-color: var(--primary);
  color: white;
  border-radius: 50%;
  width: 14px;
  height: 14px;
`;

type BoxProps = {
  disabled?: boolean;
  checked?: boolean;
  round?: boolean;
};

export const Box = styled.div<BoxProps>`
  min-width: ${checkBoxSize.width};
  min-height: ${checkBoxSize.height};
  box-sizing: border-box;
  position: relative;
  text-align: center;
  transition: all 0.1s ease-in-out;
  border: ${props => (props.checked ? `2px solid var(--primary);` : '2px solid #B1B5C4')};
  background-color: ${props => (props.checked ? 'var(--primary)' : '#F4F6F9')};
  border-radius: ${props => (props.round ? '50%' : '6px')};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  & rect {
    fill: var(--primary);
  }
`;

export const Label = styled.span`
  user-select: none;
  color: var(--font-primary);
  font-weight: bold;
`;
